// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      type: 'Container',
      name: 'rewards',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b9facdd7-c4f7-43bf-b1fa-f524e4be5fd2',
      type: 'Container',
      name: 'singleUseReward01',
      className: '',
      x: -120,
      y: -48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: -120,
          y: -48,
          visible: false
        },
        booster_3_infinite_2: {
          y: -48,
          x: -67,
          visible: true
        },
        booster_2_infinite_2: {
          x: -120,
          y: 0,
          visible: true
        },
        booster_1_infinite_2: {
          x: -67,
          y: 0,
          visible: true
        },
        booster_4_infinite_1: {
          x: -120,
          y: -48,
          visible: true
        },
        booster_3_infinite_1: {
          y: -48,
          x: -67,
          visible: true
        },
        booster_2_infinite_1: {
          x: -120,
          y: 0,
          visible: true
        },
        booster_1_infinite_1: {
          x: -67,
          y: 0,
          visible: true
        },
        booster_4_infinite_0: {
          x: -50,
          y: -48,
          visible: true
        },
        booster_3_infinite_0: {
          y: -48,
          x: 3,
          visible: true
        },
        booster_2_infinite_0: {
          x: -50,
          y: 0,
          visible: true
        },
        booster_1_infinite_0: {
          x: 3,
          y: 0,
          visible: true
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: '12f25b2a-9773-467f-a919-c465bda619ba',
      type: 'Container',
      name: 'singleUseReward02',
      className: '',
      x: -12,
      y: -48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: -12,
          y: -48,
          visible: false
        },
        booster_3_infinite_2: {
          x: -12,
          y: 45,
          visible: true
        },
        booster_2_infinite_2: {
          x: -12,
          y: 0,
          visible: true
        },
        booster_1_infinite_2: {
          visible: false
        },
        booster_4_infinite_1: {
          x: -12,
          y: -48,
          visible: true
        },
        booster_3_infinite_1: {
          x: -12,
          y: 45,
          visible: true
        },
        booster_2_infinite_1: {
          x: -12,
          y: 0,
          visible: true
        },
        booster_1_infinite_1: {
          visible: false
        },
        booster_4_infinite_0: {
          x: 58,
          y: -48,
          visible: true
        },
        booster_3_infinite_0: {
          x: 58,
          y: 45,
          visible: true
        },
        booster_2_infinite_0: {
          x: 58,
          y: 0,
          visible: true
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: '912c7db1-be85-4358-bad5-38151572a1d1',
      type: 'Container',
      name: 'singleUseReward03',
      className: '',
      x: -12,
      y: 45,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: -12,
          y: 45,
          visible: false
        },
        booster_3_infinite_2: {
          x: -120,
          y: 45,
          visible: true
        },
        booster_2_infinite_2: {
          visible: false
        },
        booster_1_infinite_2: {
          visible: false
        },
        booster_4_infinite_1: {
          x: -12,
          y: 45,
          visible: true
        },
        booster_3_infinite_1: {
          x: -120,
          y: 45,
          visible: true
        },
        booster_2_infinite_1: {
          visible: false
        },
        booster_1_infinite_1: {
          visible: false
        },
        booster_4_infinite_0: {
          x: 58,
          y: 45,
          visible: true
        },
        booster_3_infinite_0: {
          x: -50,
          y: 45,
          visible: true
        },
        booster_2_infinite_0: {
          visible: false
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: '3dcec1de-fe31-4cfe-b43f-c987ca237067',
      type: 'Container',
      name: 'singleUseReward04',
      className: '',
      x: -120,
      y: 45,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: -120,
          y: 45,
          visible: false
        },
        booster_3_infinite_2: {
          visible: false
        },
        booster_2_infinite_2: {
          visible: false
        },
        booster_1_infinite_2: {
          visible: false
        },
        booster_4_infinite_1: {
          x: -120,
          y: 45,
          visible: true
        },
        booster_3_infinite_1: {
          visible: false
        },
        booster_2_infinite_1: {
          visible: false
        },
        booster_1_infinite_1: {
          visible: false
        },
        booster_4_infinite_0: {
          x: -50,
          y: 45,
          visible: true
        },
        booster_3_infinite_0: {
          visible: false
        },
        booster_2_infinite_0: {
          visible: false
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: 'ff77416b-5900-466e-a0df-485f45646216',
      type: 'Sprite',
      name: 'rewardSeparator',
      className: '',
      x: 52,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bundle_Items_Separation_Line',
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          visible: false
        },
        booster_3_infinite_2: {
          visible: true
        },
        booster_2_infinite_2: {
          visible: true
        },
        booster_1_infinite_2: {
          visible: true
        },
        booster_4_infinite_1: {
          visible: true
        },
        booster_3_infinite_1: {
          visible: true
        },
        booster_2_infinite_1: {
          visible: true
        },
        booster_1_infinite_1: {
          visible: true
        },
        booster_4_infinite_0: {
          visible: false
        },
        booster_3_infinite_0: {
          visible: false
        },
        booster_2_infinite_0: {
          visible: false
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: 'dfdb9bf1-aeff-47c1-b0a5-db3a50c9f5e5',
      type: 'Container',
      name: 'infinityReward01',
      className: '',
      x: 104,
      y: -48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: 0,
          y: -48,
          visible: true
        },
        booster_3_infinite_2: {
          x: 104,
          y: -48,
          visible: true
        },
        booster_2_infinite_2: {
          visible: true,
          y: -48,
          x: 104
        },
        booster_1_infinite_2: {
          x: 104,
          y: -48,
          visible: true
        },
        booster_4_infinite_1: {
          x: 132,
          y: 0,
          visible: true
        },
        booster_3_infinite_1: {
          x: 132,
          y: 0,
          visible: true
        },
        booster_2_infinite_1: {
          x: 132,
          y: 0,
          visible: true
        },
        booster_1_infinite_1: {
          x: 132,
          y: 0,
          visible: true
        },
        booster_4_infinite_0: {
          visible: false
        },
        booster_3_infinite_0: {
          visible: false
        },
        booster_2_infinite_0: {
          visible: false
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: true,
          x: 0,
          y: 0
        }
      }
    },
    {
      id: 'c0aa01d9-00f4-4f2a-bd00-04bceefad3bb',
      type: 'Container',
      name: 'infinityReward02',
      className: '',
      x: 104,
      y: 45,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e3cb6bf9-02b8-4770-9755-4817e9a188e2',
      stateByName: {
        booster_0_infinite_2: {
          x: 0,
          y: 45,
          visible: true
        },
        booster_3_infinite_2: {
          x: 104,
          y: 45,
          visible: true
        },
        booster_2_infinite_2: {
          visible: true,
          y: 45,
          x: 104
        },
        booster_1_infinite_2: {
          x: 104,
          y: 45,
          visible: true
        },
        booster_4_infinite_1: {
          visible: false
        },
        booster_3_infinite_1: {
          visible: false
        },
        booster_2_infinite_1: {
          visible: false
        },
        booster_1_infinite_1: {
          visible: false
        },
        booster_4_infinite_0: {
          visible: false
        },
        booster_3_infinite_0: {
          visible: false
        },
        booster_2_infinite_0: {
          visible: false
        },
        booster_1_infinite_0: {
          visible: false
        },
        booster_0_infinite_1: {
          visible: false
        }
      }
    },
    {
      id: '3c8fc82b-b40b-4f3b-a785-34da224d710e',
      type: 'Sprite',
      name: 'rewardIconShadow01',
      className: '',
      x: 3,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 13282675,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster_Shadow',
      parent: 'b9facdd7-c4f7-43bf-b1fa-f524e4be5fd2'
    },
    {
      id: 'fad1300e-9286-428c-a1dd-cc003a3189c4',
      type: 'Sprite',
      name: 'rewardIcon01',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: 'b9facdd7-c4f7-43bf-b1fa-f524e4be5fd2'
    },
    {
      id: '3601cebc-4260-4020-872b-dbf27788897b',
      type: 'Text',
      name: 'rewardAmount01',
      className: '',
      x: 12,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b9facdd7-c4f7-43bf-b1fa-f524e4be5fd2'
    },
    {
      id: '554011f2-c711-4a9c-8bf6-aae406369f86',
      type: 'Sprite',
      name: 'rewardIconShadow02',
      className: '',
      x: 3,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 13282675,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster_Shadow',
      parent: '12f25b2a-9773-467f-a919-c465bda619ba'
    },
    {
      id: 'e39acdc5-2fc1-4848-8984-840f8a94d737',
      type: 'Sprite',
      name: 'rewardIcon02',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '12f25b2a-9773-467f-a919-c465bda619ba'
    },
    {
      id: '86d6d223-a117-45d1-bd8b-f5621ad0bfb3',
      type: 'Text',
      name: 'rewardAmount02',
      className: '',
      x: 13,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '12f25b2a-9773-467f-a919-c465bda619ba'
    },
    {
      id: '28492b01-214c-4dd1-b47f-49fdfbdf360e',
      type: 'Sprite',
      name: 'rewardIconShadow03',
      className: '',
      x: 3,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 13282675,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster_Shadow',
      parent: '912c7db1-be85-4358-bad5-38151572a1d1'
    },
    {
      id: 'ae8d40d2-d29a-48ba-a481-5c7fadcf9409',
      type: 'Sprite',
      name: 'rewardIcon03',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '912c7db1-be85-4358-bad5-38151572a1d1'
    },
    {
      id: '609d611c-2f59-4ce6-86c7-89dcc9a243c0',
      type: 'Text',
      name: 'rewardAmount03',
      className: '',
      x: 13,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '912c7db1-be85-4358-bad5-38151572a1d1'
    },
    {
      id: '392f4202-1ed0-4b88-a1e2-4d6349e591d2',
      type: 'Sprite',
      name: 'rewardIconShadow04',
      className: '',
      x: 3,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 13282675,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster_Shadow',
      parent: '3dcec1de-fe31-4cfe-b43f-c987ca237067'
    },
    {
      id: '20f05529-b3e7-45b1-bb93-ca864db03788',
      type: 'Sprite',
      name: 'rewardIcon04',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.323,
        y: 0.323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '3dcec1de-fe31-4cfe-b43f-c987ca237067'
    },
    {
      id: '5eae4aff-1b21-4099-b4b4-f43cab21c7d0',
      type: 'Text',
      name: 'rewardAmount04',
      className: '',
      x: 12,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3dcec1de-fe31-4cfe-b43f-c987ca237067'
    },
    {
      id: 'f9201468-8b2c-43ba-ac7f-4ad3c1f4c5f1',
      type: 'Sprite',
      name: 'rewardIcon05',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.4,
        y: 1.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: 'dfdb9bf1-aeff-47c1-b0a5-db3a50c9f5e5',
      stateByName: {
        booster_4_infinite_1: {
          scale: {
            x: 2,
            y: 2
          }
        },
        booster_3_infinite_1: {
          scale: {
            x: 2,
            y: 2
          }
        },
        booster_2_infinite_1: {
          scale: {
            x: 2,
            y: 2
          }
        },
        booster_1_infinite_1: {
          scale: {
            x: 2,
            y: 2
          }
        },
        booster_0_infinite_1: {
          scale: {
            x: 2,
            y: 2
          }
        }
      }
    },
    {
      id: 'c9546b34-d22d-4ca9-bd5a-985f0be4fb4f',
      type: 'Text',
      name: 'rewardAmount05',
      className: '',
      x: 29,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXh',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'dfdb9bf1-aeff-47c1-b0a5-db3a50c9f5e5',
      stateByName: {
        booster_4_infinite_1: {
          x: 0,
          y: 77
        },
        booster_3_infinite_1: {
          x: 0,
          y: 77
        },
        booster_2_infinite_1: {
          x: 0,
          y: 77
        },
        booster_1_infinite_1: {
          x: 0,
          y: 77
        },
        booster_0_infinite_1: {
          x: 0,
          y: 77
        }
      }
    },
    {
      id: '62d43ac3-2ca5-412b-a923-058083d1eb3c',
      type: 'Sprite',
      name: 'rewardIcon06',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.4,
        y: 1.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: 'c0aa01d9-00f4-4f2a-bd00-04bceefad3bb'
    },
    {
      id: '9a31de36-e05e-48fc-8aa1-223fcd7c5465',
      type: 'Text',
      name: 'rewardAmount06',
      className: '',
      x: 29,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXh',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c0aa01d9-00f4-4f2a-bd00-04bceefad3bb'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'booster_0_infinite_2',
    'booster_3_infinite_2',
    'booster_2_infinite_2',
    'booster_1_infinite_2',
    'booster_4_infinite_1',
    'booster_3_infinite_1',
    'booster_2_infinite_1',
    'booster_1_infinite_1',
    'booster_4_infinite_0',
    'booster_3_infinite_0',
    'booster_2_infinite_0',
    'booster_1_infinite_0',
    'booster_0_infinite_1'
  ],
  handleResize: false
} as const;

export class ShopOfferRewardsLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  rewards!: Container;
  singleUseReward01!: Container;
  singleUseReward02!: Container;
  singleUseReward03!: Container;
  singleUseReward04!: Container;
  rewardSeparator!: Sprite;
  infinityReward01!: Container;
  infinityReward02!: Container;
  rewardIconShadow01!: Sprite;
  rewardIcon01!: Sprite;
  rewardAmount01!: Text;
  rewardIconShadow02!: Sprite;
  rewardIcon02!: Sprite;
  rewardAmount02!: Text;
  rewardIconShadow03!: Sprite;
  rewardIcon03!: Sprite;
  rewardAmount03!: Text;
  rewardIconShadow04!: Sprite;
  rewardIcon04!: Sprite;
  rewardAmount04!: Text;
  rewardIcon05!: Sprite;
  rewardAmount05!: Text;
  rewardIcon06!: Sprite;
  rewardAmount06!: Text;
  StateName!: 'booster_0_infinite_2' | 'booster_3_infinite_2' | 'booster_2_infinite_2' | 'booster_1_infinite_2' | 'booster_4_infinite_1' | 'booster_3_infinite_1' | 'booster_2_infinite_1' | 'booster_1_infinite_1' | 'booster_4_infinite_0' | 'booster_3_infinite_0' | 'booster_2_infinite_0' | 'booster_1_infinite_0' | 'booster_0_infinite_1';

  constructor() {
    populate(this, raw);
  }
}
